import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ItemObject } from 'src/app/models/orders/item/item-object.model';
import { OrderTypeObject } from 'src/app/models/orders/order-type-object.model';
import { OrderSummary } from 'src/app/services/api/orders/orders.service';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-order-depth-level',
  templateUrl: './order-depth-level.component.html',
  styleUrls: ['./order-depth-level.component.scss']
})
export class OrderDepthLevelComponent implements OnInit {

  @Input() summary: OrderSummary;
  @Input() params: any;
  @Input() isps: any[];

  @Output() cancelOrderEvent = new EventEmitter();
  @Output() decompositeOrderEvent = new EventEmitter();

  constructor() {

  }

  ngOnInit(): void {

  }

  cancelOrder() {
    this.cancelOrderEvent.emit();
  }

  decompositeOrder() {
    this.decompositeOrderEvent.emit();
  }
}
